import axiosInstance from "../../axiosInstance";

// دالة لجلب الكتب 
export const fetchBooks = async (params) => {
  try {
    const response = await axiosInstance.get('/api/v1/speakers/books', {
      params: {
        page: params?.page || 1,
        pageSize: params?.pageSize || 10
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('خطأ في جلب الكتب:', error);
    throw error;
  }
};


// دالة لإضافة كتاب جديد
export const createBook = async (bookData) => {
  try {
    const response = await axiosInstance.post(
      "/api/v1/speakers/books",
      bookData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating book:", error);
    throw error;
  }
};

// دالة لجلب كتاب محدد حسب bookId
export const fetchBookById = async (bookId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/speakers/books/${bookId}`);

    if (response.data) {
      return response.data;
    } else {
      throw new Error("Book not found.");
    }
  } catch (error) {
    console.error("Error fetching book by ID:", error);
    throw error;
  }
};

// دالة لتحديث كتاب موجود
export const updateBook = async (bookId, formData) => {
  try {
    const response = await axiosInstance.put(`/api/v1/speakers/books/${bookId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("خطأ API التحديث:", error);
    throw error;
  }
};

// دالة لحذف كتاب
export const deleteBook = async (bookId) => {
  try {
    const response = await axiosInstance.delete(`/api/v1/speakers/books/${bookId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting book:", error);
    throw error;
  }
};